var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.logic && _vm.logic.created)?_c('div',[_c('artikel-edit',{attrs:{"artikel":_vm.logic.artikel,"primaryColor":_vm.logic.filiale.colorPrimary,"secondaryColor":_vm.logic.filiale.colorSecondary,"darkMode":_vm.logic.filiale.darkMode},on:{"added-to-warenkorb":_vm.added}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }